import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddAddressModalComponent } from '../add-address-modal/add-address-modal.component';

@Component({
  selector: 'app-address-selection-modal',
  templateUrl: './address-selection-modal.component.html',
  styleUrl: './address-selection-modal.component.scss',
})
export class AddressSelectionModalComponent implements OnInit{
  @Input() addresses: any[] = [];
  @Input() defaultAddress?: any;
  selectedAddress: any = null;

  constructor(public activeModal: NgbActiveModal, private modal: NgbModal) {}


  ngOnInit(): void {
    console.log('addresses', this.addresses);
    console.log('defaultAddress', this.defaultAddress);
  }

  confirmSelection() {
    if (this.selectedAddress) {
      this.activeModal.close(this.selectedAddress);
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }

  select(addr: any) {
    this.selectedAddress = addr;
  }

  addAddress() {
    const modalRef = this.modal.open(AddAddressModalComponent, {
      size: 'lg',
      centered: true,
    });

    modalRef.componentInstance.defaultAddress = this.defaultAddress;

    modalRef.result
      .then((newAddress) => {
        if (newAddress) {
          // handle saved address, e.g. refresh list or pass data upward
          console.log('New address added:', newAddress);

          this.addresses.push(newAddress);
          this.selectedAddress = newAddress;
        }
      })
      .catch(() => {
        // modal dismissed by clicking outside or pressing ESC
      });
  }
}
